export const MapErrorMessage = (code, constantsArray) => {
    const constant = constantsArray.find(item => item.code === code);
    return constant ? constant.message : constantsArray.find(item => item.code === 'DEFAULT').message;
  };